import { Rescore } from '@/features/updateView/rescore'

export const UpdatePageView = () => {
  return <Rescore />
}
